import { useCallback, useMemo } from 'react'

import { useAuthUser } from '@common/hooks/useAuthUser'

import { getCurrentUser as _getCurrentUser } from '../user'
import type { UserProfile } from '../user.interface'

import { useUserStore } from './user.store'

export function useUser() {
  const { user: auth0User } = useAuthUser()
  const { currentUser, invitations, loading, error, setState } = useUserStore()

  const profile = useMemo((): UserProfile | undefined => {
    if (!auth0User) return undefined
    return {
      nickname: auth0User.nickname ?? null,
      name: auth0User.name ?? null,
      picture: auth0User.picture ?? null,
      email: auth0User.email ?? null,
      email_verified: auth0User.email_verified,
      sub: auth0User.sub,
    }
  }, [auth0User])

  const fetchCurrentUser = useCallback(async () => {
    try {
      setState({ loading: true, error: null })
      const user = await _getCurrentUser()
      setState({
        currentUser: user
          ? {
              ...user,
              profile,
            }
          : null,
      })
    } catch (err) {
      setState({ currentUser: null })
      throw err
    } finally {
      setState({ loading: false })
    }
  }, [setState, profile])

  const getCurrentUser = fetchCurrentUser

  return {
    currentUser,
    invitations,
    loading,
    error,
    getCurrentUser,
  }
}
